import { render, staticRenderFns } from "./OrderCreateStep5.vue?vue&type=template&id=5d9ef01e&"
import script from "./OrderCreateStep5.vue?vue&type=script&lang=js&"
export * from "./OrderCreateStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports